import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PosthogService } from '../../services/posthog.service';
import { ToHtmlPipe } from '../../utilities/to-htmlpipe/to-html.pipe';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';

@Component({
  selector: 'app-common-explore-global-panel',
  templateUrl: './explore-more.component.html',
  styleUrls: ['./explore-more.component.scss'],
  imports: [CommonModule, ToHtmlPipe, UrlParamsPipe],
})
export class CommonExploreGlobalPanelComponent implements OnInit, OnDestroy {
  @Input() exploreData: any;
  @Input() noRedirect!: boolean;
  exploreMorePanelData: any;
  queryParams: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute,
    private posthog: PosthogService
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  ngOnInit(): void {
    this.exploreMorePanelData = this.exploreData;
  }
  ngOnChanges(): void {
    this.exploreMorePanelData = this.exploreData;
  }

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    nav: true,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  ngOnDestroy(): void {}

  onProductCardClick(productTitle: string, url: string): void {
    const cardType = url?.includes('/solutions/') ? 'solution' : 'product';
    const currentUrl = isPlatformBrowser(this.platformId) && typeof window !== 'undefined' 
      ? window.location.pathname 
      : '';
    const pageName = currentUrl.split('/').filter(s => s).pop() || 'home';
    
    this.posthog.captureCardClick(productTitle, cardType, pageName, {
      destinationUrl: url
    });
  }
}
